var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p2p"},[_c('v-row',[_c('v-col',[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.$t('Trade id:'))+" ")]),_c('router-link',{attrs:{"to":{
          name: 'p2p-offers-and-deals',
          query: {
            DealsSearchString: _vm.tradeId,
          },
        },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.tradeId)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }